<template>
  <v-row dense justify="center" class="text-left" v-if="!lodash.isEmpty(notesByCategory)">
    <v-col cols="11">
      <v-card>
        <v-hover
          @click.native="expanded = !expanded"
          v-ripple="{ center: true }"
          v-slot:default="{ hover }"
        >
          <v-sheet
            :color="$Color().colorFor(noteCategory.color)"
            :dark="$Color().colorText(noteCategory.color) === $Color().brightText"
            :class="['px-2', hover ? 'hover' : '']"
          >
            <v-row dense align="center" class="text-body-2">
              <v-col>
                {{ noteCategory.name }}
              </v-col>

              <v-col cols="auto">
                <v-btn icon x-small>
                  <v-icon v-if="expanded">eva-chevron-up-outline</v-icon>
                  <v-icon v-else>eva-chevron-down-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>
        </v-hover>

        <v-row no-gutters v-for="note in notesByCategory" :key="note.id" v-show="expanded">
          <v-col>
            <AttendanceNote :note="note" :categoryName="noteCategory.name" :attendanceId="attendanceId" />

            <v-divider />
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import AttendanceNote from "@/components/attendance/note.vue";

  export default {
    name: "NoteCategory",
    components: {
      AttendanceNote,
    },
    data() {
      return {
        expanded: true,
      };
    },
    props: {
      attendanceId: String,
      noteCategory: Object,
      notesByCategory: Array
    }
  };
</script>

<style lang="scss" scoped></style>
